import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { products } from "../config/products";
import ProductCard from "../components/ProductCard";
import SectionHeading from "../components/SectionHeading";
import { links } from "../config/links";
import "./Home.css";

function Home() {
  const values = [
    {
      icon: "◆",
      label: "Teach & Empower",
      desc: "We don't just build tools — we teach you how to own them.",
    },
    {
      icon: "◆",
      label: "Solid Solutions",
      desc: "Every workflow is tested in real environments before release.",
    },
    {
      icon: "◆",
      label: "Your Systems",
      desc: "All solutions run on your infrastructure. No cloud, no data leaving.",
    },
    {
      icon: "◆",
      label: "No Bloat",
      desc: "Focused tools that do one thing well — no complicated platforms.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>AxiomLabs Solutions — Enterprise Software Company</title>
        <meta
          name="description"
          content="AxiomLabs Solutions builds enterprise software across security, AI, automation, compliance, and infrastructure. Single binaries, no cloud, no telemetry. One-time purchase, owned forever."
        />
      </Helmet>
      <div className="home-page">
        {/* Hero */}
        <section className="home-hero">
          <div className="container">
            <div className="home-hero__content">
              <span className="home-hero__eyebrow">AxiomLabs Solutions</span>
              <h1 className="home-hero__title">
                We build workflows and apps that solve real problems. Then we
                teach you how to own them.
              </h1>
              <p className="home-hero__text">
                Created by practitioners, for practitioners. No subscriptions,
                no platforms to learn. Just focused tools that do one job well.
              </p>
              <div className="home-hero__cta">
                <Link
                  to="/products"
                  className="home-hero__button home-hero__button--primary"
                >
                  <span>View Our Tools</span>
                  <span className="arrow">→</span>
                </Link>
                <a
                  href={`mailto:${links.email}`}
                  className="home-hero__button home-hero__button--secondary"
                >
                  <span>Get in Touch</span>
                  <span className="arrow">→</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Products */}
        <section className="home-products">
          <div className="container">
            <SectionHeading
              eyebrow="What We Build"
              title="Our Solutions"
              subheading="One purchase, owned forever. No subscriptions. No cloud."
            />

            <div className="home-products__grid">
              {products.map((product, i) => (
                <ProductCard
                  key={i}
                  name={product.name}
                  tagline={product.tagline}
                  description={product.description}
                  status={product.status}
                  path={product.path}
                  featured={product.featured}
                  new={product.new}
                  icon={product.icon}
                  color={product.color}
                  license={product.license}
                  tags={product.tags}
                  openSource={product.openSource}
                  githubUrl={product.githubUrl}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="home-values">
          <div className="container">
            <SectionHeading
              eyebrow="Our Approach"
              title="How We Work"
              subheading="We build, we teach, we get out of your way."
            />

            <div className="home-values__grid">
              {values.map((v, i) => (
                <div key={i} className="home-value-card">
                  <span className="home-value-card__icon">{v.icon}</span>
                  <h3 className="home-value-card__label">{v.label}</h3>
                  <p className="home-value-card__desc">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="home-cta">
          <div className="container">
            <div className="home-cta__card">
              <h2 className="home-cta__title">Ready to own your workflows?</h2>
              <p className="home-cta__text">
                Talk directly to the engineers who build the tools. No ticket
                queues.
              </p>
              <a href={`mailto:${links.email}`} className="home-cta__button">
                <span>Email Us</span>
                <span className="arrow">→</span>
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
